<template>
  <div class="home-page">
    <el-card shadow="never" class="welcome-card">
      <div class="welcome">
        <h2>🐔 欢迎使用种鸡育种管理系统</h2>
        <p>菜单按模块划分,当前展示模拟数据,后期将切换为后端接口数据</p>
      </div>
    </el-card>

    <el-row :gutter="16">
      <!-- 响应式布局:手机 1 列、平板 2 列、笔记本 3 列、大屏 4 列 -->
      <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="m in modules" :key="m.key" class="grid-item">
        <el-card shadow="hover" class="module-card" @click="go(m)">
          <div class="module-name">{{ m.name }}</div>
          <div class="module-desc">
            {{ m.isGroup ? `${m.children.length} 类报表` : `${m.columns.length} 个字段项` }}
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { modules } from '@/config/modules'

const router = useRouter()

function go(m) {
  router.push(m.isGroup ? m.children[0].path : m.path)
}
</script>

<style scoped>
.welcome-card {
  margin-bottom: 16px;
}
.welcome {
  text-align: center;
  padding: 12px 0;
}
.welcome p {
  color: #909399;
  margin-top: 8px;
}
.module-card {
  cursor: pointer;
  text-align: center;
  margin-bottom: 16px;
  transition: transform 0.2s;
}
.module-card:hover {
  transform: translateY(-4px);
}
.module-name {
  font-weight: 600;
  font-size: 15px;
}
.module-desc {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}
/* 移动端适配:单列铺满、卡片内边距收紧 */
@media (max-width: 768px) {
  .welcome h2 {
    font-size: 18px;
  }
  .welcome p {
    font-size: 13px;
    line-height: 1.6;
  }
  .welcome-card :deep(.el-card__body) {
    padding: 8px 10px;
  }
  .module-card :deep(.el-card__body) {
    padding: 12px 10px;
  }
  .module-card:hover {
    transform: none;
  }
}
</style>
